declare global {
    interface Window {
        unifiedTrackingInstance?: {
            trackUserBehavior: (eventName: string, payload: object) => void;
        };
        unifiedTrackingHandler?: {
            api: {
                handleEvent: (event: object) => void;
            };
        };
    }
}

export const track = (eventName: string, payload: object) => {
    if (window.unifiedTrackingInstance) {
        window.unifiedTrackingInstance.trackUserBehavior(eventName, payload);
    } else if (window.unifiedTrackingHandler) {
        window.unifiedTrackingHandler.api.handleEvent({ unifiedEvent: true, eventName, ...payload });
    } else {
        console.warn("UBE tracking: no tracking instance available");
    }
};
